import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Icon } from '@liftango/ui-icons';
import { ICON_FALLBACKS } from '../../../utils/iconFallbacks';
export type DataType = 'locations' | 'routes' | 'fleets' | 'rides' | 'serviceInfo';

interface DataTypeTabsProps {
  selectedTab: DataType;
  onTabChange: (tab: DataType) => void;
}

export const DataTypeTabs: React.FC<DataTypeTabsProps> = ({
  selectedTab,
  onTabChange
}) => {
  const { t } = useTranslation('map');
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const tabs: DataType[] = ['locations', 'routes', 'fleets', 'rides', 'serviceInfo'];
    onTabChange(tabs[newValue]);
  };

  const getTabIndex = (tab: DataType): number => {
    const tabs: DataType[] = ['locations', 'routes', 'fleets', 'rides', 'serviceInfo'];
    return tabs.indexOf(tab);
  };

  return (
    <Box>
      <Tabs
        value={getTabIndex(selectedTab)}
        onChange={handleChange}
        aria-label={t('dataTransfer.tabs.ariaLabel')}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          data-testid="transfer.tabs.locations"
          icon={<Icon size={20} name="location-dot" />}
          iconPosition="start"
          label={t('dataTransfer.tabs.locations')}
        />
        <Tab
          data-testid="transfer.tabs.routes"
          icon={<Icon size={20} d={ICON_FALLBACKS.AltRoute} />}
          iconPosition="start"
          label={t('dataTransfer.tabs.routes')}
        />
        <Tab
          data-testid="transfer.tabs.fleets"
          icon={<Icon size={20} name="bus" />}
          iconPosition="start"
          label={t('dataTransfer.tabs.fleets')}
        />
        <Tab
          data-testid="transfer.tabs.rides"
          icon={<Icon size={20} name="users" />}
          iconPosition="start"
          label={t('dataTransfer.tabs.rides')}
        />
        <Tab
          data-testid="transfer.tabs.service-info"
          icon={<Icon size={20} name="circle-info" />}
          iconPosition="start"
          label={t('dataTransfer.tabs.serviceInfo')}
        />
      </Tabs>
    </Box>
  );
};

export default DataTypeTabs;

